import axios, { AxiosResponse } from 'axios';
import { put, takeLatest, select , all, takeEvery} from 'redux-saga/effects';
import actions from '@state/actions';
import selectors from '@state/selectors';
import { serverError } from '@state/auth/actions';
import host from '@utils/host';
import * as actionsTypes from './constants';
import * as actionsInterfaces from './types';
import { UserManager } from 'oidc-client';
import { act } from 'react-dom/test-utils';

function* fetchBrands(action: actionsInterfaces.IFetchBrandsAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    let callUrl=`${host}brands`    
    if(action.query)callUrl=`${host}brands${action.query}`

    const response: AxiosResponse<any> = yield axios.get(callUrl,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.brands.setBrands(response.data));
      if (action.callback) { action.callback(response.data); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* getBrand(action: actionsInterfaces.IFetchBrandAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    let callUrl=`${host}brands`    
    if(action.query)callUrl=`${host}brands${action.query}`
    const response: AxiosResponse<any> = yield axios.get(callUrl,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.brands.setBrand(response.data));
      if (action.callback) { action.callback(response.data); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* addBrand(action: actionsInterfaces.IPostBrandAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    const response: AxiosResponse<any> = yield axios.post(`${host}brands`, action.brand,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.brands.addSuccessBrand({status:response.status, id:action.brand.id, name:action.brand.name, design:response.data}));
      if (action.callback) { action.callback(response.data[0]); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      yield put(actions.brands.addSuccessBrand({status:response.status, id:action.brand.id, name:action.brand.name}));
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* addCustomMetaDataVehicle(action: actionsInterfaces.IPostCustomMetaDataVehicleAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    const response: AxiosResponse<any> = yield axios.post(`${host}addCustomData`, action.customMetaData,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.brands.addSuccessCustomMetaDataVehicles({status:response.status, customMetaDataVehicleResponse: action.customMetaData, result: response.data}));
      if (action.callback) { action.callback(response.data[0]); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      yield put(actions.brands.addSuccessCustomMetaDataVehicles({status:response.status, customMetaDataVehicleResponse: action.customMetaData, result: response.data}));
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* fetchSearchBrands(action: actionsInterfaces.IFetchBrandsAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    let callUrl=`${host}brands`    
    if(action.query)callUrl=`${host}brands${action.query}`
    const response: AxiosResponse<any> = yield axios.get(callUrl,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.brands.setSearchBrands(response.data));
      if (action.callback) { action.callback(response.data); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* updateBrand(action: actionsInterfaces.IUpdateBrandAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    const response: AxiosResponse<any> = yield axios.put(`${host}brands/${action.brand.id}`,action.brand,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      //if (action.location==='FAVORITES') yield put(actions.brands.addBrandSuccessFavorite({status:response.status, id:action.brand.id, favorite:action.brand.favorite, name:action.design.name}));
      if (action.callback) { action.callback(response); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* deleteBrand(action: actionsInterfaces.IDeleteBrandAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    let queryparams = `${action.brand.id}?email=${action.brand.updatedBy.email}&name=${action.brand.updatedBy.name}`
    //const response: AxiosResponse<any> = yield axios.delete(`${host}brands/${queryparams}`,{headers: {Authorization: token}})
    const response: AxiosResponse<any> = yield axios.delete(`${host}brands/${queryparams}`,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.brands.deleteBrandSuccess());
      if (action.callback) { action.callback(response); }        
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* fetchCounter(action: actionsInterfaces.IFetchCounterAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    let callUrl=`${host}brandscount`    
    if(action.filter)callUrl=`${host}brandscount${action.filter}`
    const response: AxiosResponse<any> = yield axios.get(callUrl,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.brands.setCounterBrands(response.data[0]));
      if (action.callback) { action.callback(response.data); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* updateBrands(action: actionsInterfaces.IUpdateBrandsAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    const response: AxiosResponse<any> = yield axios.post(`${host}brands-update`,action.brands,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      if (action.callback) { action.callback(response); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* getBrandName(action: actionsInterfaces.IFetchBrandAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    let callUrl=`${host}getbrandname`    
    if(action.query)callUrl=`${host}getbrandname${action.query}`
    const response: AxiosResponse<any> = yield axios.get(callUrl,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.brands.setBrandName(response.data));
      if (action.callback) { action.callback(response.data); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

  function* addUpdateBrand(action: actionsInterfaces.IAddUpdateBrandAction) {
    let token: string;
    try {
      token = yield select(selectors.auth.getAuthToken);
      const response: AxiosResponse<any> = yield axios.post(`${host}updatebrand`,action.brandInformation,{headers: {Authorization: token}})
      yield put(actions.brands.setAddUpdateSnackBar({snackBar: action.snackbarText, status: response.status}));
      if (response.status >= 200 && response.status <= 300) {
        yield put(actions.brands.setAddUpdateBrand(response.data));
        if (action.callback) { action.callback(response); }  
      } else if (response.status === 400 || response.status === 401 || response.status === 403) {
        const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
        if (userManager) yield userManager.signoutRedirect();
        yield put(actions.auth.setAuth(undefined, undefined, undefined));
        if (action.callback) { action.callback(undefined, response); }  
      } else {
        yield put(serverError(response.data));
        if (action.callback) { action.callback(undefined, response); }  
      }  
    } catch (e) {
      yield put(serverError(e));
      if (action.callback) { action.callback(undefined, e); }    
    }
  }

  function* moveFile(action: actionsInterfaces.IMoveFileAction) {
    let token: string;
    try {
      token = yield select(selectors.auth.getAuthToken);
      const response: AxiosResponse<any> = yield axios.post(`${host}backUpDeletedImage`,action.backUpInformation,{headers: {Authorization: token}})
      if (response.status >= 200 && response.status <= 300) {
        yield put(actions.brands.setMovefileResponse({status: response.status, data: response.data}));
        if (action.callback) { action.callback(response); }  
      } else if (response.status === 400 || response.status === 401 || response.status === 403) {
        const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
        if (userManager) yield userManager.signoutRedirect();
        yield put(actions.auth.setAuth(undefined, undefined, undefined));
        if (action.callback) { action.callback(undefined, response); }  
      } else {
        yield put(serverError(response.data));
        if (action.callback) { action.callback(undefined, response); }  
      }  
    } catch (e) {
      yield put(serverError(e));
      if (action.callback) { action.callback(undefined, e); }    
    }
  }

  function* fetchYears(action: actionsInterfaces.IFetchYearsAction) {
    let token: string;
    try {
      token = yield select(selectors.auth.getAuthToken);
      let callUrl=`${host}brands_data/years?oem=${action.oem??""}&userdata=${action.userdata}` 
      const response: AxiosResponse<any> = yield axios.get(callUrl,{headers: {Authorization: token}})
      if (response.status >= 200 && response.status <= 300) {
        if (action.callback) { action.callback(response.data); }  
      } else if (response.status === 400 || response.status === 401 || response.status === 403) {
        const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
        if (userManager) yield userManager.signoutRedirect();
        yield put(actions.auth.setAuth(undefined, undefined, undefined));
        if (action.callback) { action.callback(undefined, response); }  
      } else {
        yield put(serverError(response.data));
        if (action.callback) { action.callback(undefined, response); }  
      }  
    } catch (e) {
      yield put(serverError(e));
      if (action.callback) { action.callback(undefined, e); }    
    }
  }

  function* fetchMakes(action: actionsInterfaces.IFetchMakesAction) {
    let token: string;
    try {
      token = yield select(selectors.auth.getAuthToken);
      let callUrl=`${host}brands_data/${action.year}/makes?useremail=${action.useremail}&role=${action.userRole?.toLowerCase()}` 
      const response: AxiosResponse<any> = yield axios.get(callUrl,{headers: {Authorization: token}})
      if (response.status >= 200 && response.status <= 300) {
        if (action.callback) { action.callback(response.data); }  
      } else if (response.status === 400 || response.status === 401 || response.status === 403) {
        const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
        if (userManager) yield userManager.signoutRedirect();
        yield put(actions.auth.setAuth(undefined, undefined, undefined));
        if (action.callback) { action.callback(undefined, response); }  
      } else {
        yield put(serverError(response.data));
        if (action.callback) { action.callback(undefined, response); }  
      }  
    } catch (e) {
      yield put(serverError(e));
      if (action.callback) { action.callback(undefined, e); }    
    }
  }

  function* fetchModels(action: actionsInterfaces.IFetchModelsAction) {
    let token: string;
    try {
      token = yield select(selectors.auth.getAuthToken);
      let callUrl=`${host}brands_data/${action.year}/${action.make}/models?oem=${action.oem??""}&userdata=${action.userdata}` 
      const response: AxiosResponse<any> = yield axios.get(callUrl,{headers: {Authorization: token}})
      if (response.status >= 200 && response.status <= 300) {
        if (action.callback) { action.callback(response.data); }  
      } else if (response.status === 400 || response.status === 401 || response.status === 403) {
        const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
        if (userManager) yield userManager.signoutRedirect();
        yield put(actions.auth.setAuth(undefined, undefined, undefined));
        if (action.callback) { action.callback(undefined, response); }  
      } else {
        yield put(serverError(response.data));
        if (action.callback) { action.callback(undefined, response); }  
      }  
    } catch (e) {
      yield put(serverError(e));
      if (action.callback) { action.callback(undefined, e); }    
    }
  }

  function* fetchTrims(action: actionsInterfaces.IFetchTrimsAction) {
    let token: string;
    try {
      token = yield select(selectors.auth.getAuthToken);
      let callUrl=`${host}brands_data/${action.year}/${action.make}/${action.model}/trims?oem=${action.oem??""}&userdata=${action.userdata}` 
      const response: AxiosResponse<any> = yield axios.get(callUrl,{headers: {Authorization: token}})
      if (response.status >= 200 && response.status <= 300) {
        if (action.callback) { action.callback(response.data); }  
      } else if (response.status === 400 || response.status === 401 || response.status === 403) {
        const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
        if (userManager) yield userManager.signoutRedirect();
        yield put(actions.auth.setAuth(undefined, undefined, undefined));
        if (action.callback) { action.callback(undefined, response); }  
      } else {
        yield put(serverError(response.data));
        if (action.callback) { action.callback(undefined, response); }  
      }  
    } catch (e) {
      yield put(serverError(e));
      if (action.callback) { action.callback(undefined, e); }    
    }
  }

  function* fetchStyles(action: actionsInterfaces.IFetchStylesAction) {
    let token: string;
    try {
      token = yield select(selectors.auth.getAuthToken);
      let callUrl=`${host}brands_data/${action.year}/${action.make}/${action.model}/${action.trim}/styles&userdata=${action.userdata}` 
      const response: AxiosResponse<any> = yield axios.get(callUrl,{headers: {Authorization: token}})
      if (response.status >= 200 && response.status <= 300) {
        if (action.callback) { action.callback(response.data); }  
      } else if (response.status === 400 || response.status === 401 || response.status === 403) {
        const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
        if (userManager) yield userManager.signoutRedirect();
        yield put(actions.auth.setAuth(undefined, undefined, undefined));
        if (action.callback) { action.callback(undefined, response); }  
      } else {
        yield put(serverError(response.data));
        if (action.callback) { action.callback(undefined, response); }  
      }  
    } catch (e) {
      yield put(serverError(e));
      if (action.callback) { action.callback(undefined, e); }    
    }
  }

  function* fetchVehicles(action: actionsInterfaces.IFetchVehiclesAction) {
    let token: string;
    try {
      token = yield select(selectors.auth.getAuthToken);
      let callUrl=`${host}brands_data/${action.year}/${action.make}/${action.model}/vehicles?trim=${action.trim}&type=${action.imgtype}&userdata=${action.userdata}` 
      const response: AxiosResponse<any> = yield axios.get(callUrl,{headers: {Authorization: token}})
      if (response.status >= 200 && response.status <= 300) {
        yield put(actions.brands.setVehicle(response.data));
        if (action.callback) { action.callback(response.data); }  
      } else if (response.status === 400 || response.status === 401 || response.status === 403) {
        const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
        if (userManager) yield userManager.signoutRedirect();
        yield put(actions.auth.setAuth(undefined, undefined, undefined));
        if (action.callback) { action.callback(undefined, response); }  
      } else {
        yield put(serverError(response.data));
        if (action.callback) { action.callback(undefined, response); }  
      }  
    } catch (e) {
      yield put(serverError(e));
      if (action.callback) { action.callback(undefined, e); }    
    }
  }

  function* fetchDataStyles(action: actionsInterfaces.IFetchDataStylesAction) {
    let token: string;
    try {
      token = yield select(selectors.auth.getAuthToken);
      let callUrl=`${host}chromedata/${action.year}/${action.make}/${action.model}/${action.trim}` 
      const response: AxiosResponse<any> = yield axios.get(callUrl,{headers: {Authorization: token}})
      if (response.status >= 200 && response.status <= 300) {
        yield put(actions.brands.setData(response.data));
        if (action.callback) { action.callback(response.data); }  
      } else if (response.status === 400 || response.status === 401 || response.status === 403) {
        const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
        if (userManager) yield userManager.signoutRedirect();
        yield put(actions.auth.setAuth(undefined, undefined, undefined));
        if (action.callback) { action.callback(undefined, response); }  
      } else {
        yield put(serverError(response.data));
        if (action.callback) { action.callback(undefined, response); }  
      }  
    } catch (e) {
      yield put(serverError(e));
      if (action.callback) { action.callback(undefined, e); }    
    }
  }

  function* fetchData(action: actionsInterfaces.IFetchDataAction) {
    let token: string;
    try {
      token = yield select(selectors.auth.getAuthToken);
      let callUrl=`${host}chromedata/${action.style}` 
      const response: AxiosResponse<any> = yield axios.get(callUrl,{headers: {Authorization: token}})
      if (response.status >= 200 && response.status <= 300) {
        yield put(actions.brands.setData(response.data));
        if (action.callback) { action.callback(response.data); }  
      } else if (response.status === 400 || response.status === 401 || response.status === 403) {
        const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
        if (userManager) yield userManager.signoutRedirect();
        yield put(actions.auth.setAuth(undefined, undefined, undefined));
        if (action.callback) { action.callback(undefined, response); }  
      } else {
        yield put(serverError(response.data));
        if (action.callback) { action.callback(undefined, response); }  
      }  
    } catch (e) {
      yield put(serverError(e));
      if (action.callback) { action.callback(undefined, e); }    
    }
  }

export default function* budgetSagas() {
  yield all([
    takeEvery(actionsTypes.FETCH_BRANDS, fetchBrands),
    takeLatest(actionsTypes.GET_BRAND_INFO, getBrand),
    takeEvery(actionsTypes.ADD_BRAND, addBrand),
    takeEvery(actionsTypes.ADD_CUSTOM_META_DATA_VEHICLE, addCustomMetaDataVehicle),
    takeLatest(actionsTypes.FETCH_SEARCH_BRANDS, fetchSearchBrands),
    //takeLatest(actionsTypes.FETCH_BRAND_COUNTERS, fetchBrandCounters),
    takeEvery(actionsTypes.UPDATE_BRAND, updateBrand),
    takeEvery(actionsTypes.DELETE_BRAND, deleteBrand),
    takeLatest(actionsTypes.UPDATE_BRANDS, updateBrands),
    //takeLatest(actionsTypes.UPDATE_DESIGNS_FIELDS, updateDesignsFields),
    takeLatest(actionsTypes.FETCH_COUNTER_BRANDS, fetchCounter),
    takeLatest(actionsTypes.GET_BRAND_NAME, getBrandName),
    takeLatest(actionsTypes.ADD_UPDATE_BRAND, addUpdateBrand),
    takeLatest(actionsTypes.BACKUP_MOVE_FILE, moveFile),
    takeLatest(actionsTypes.FETCH_YEARS, fetchYears),
    takeLatest(actionsTypes.FETCH_MAKES, fetchMakes),
    takeLatest(actionsTypes.FETCH_MODELS, fetchModels),
    takeLatest(actionsTypes.FETCH_TRIMS, fetchTrims),
    takeLatest(actionsTypes.FETCH_STYLES, fetchStyles),
    takeLatest(actionsTypes.FETCH_VEHICLES, fetchVehicles),
    takeLatest(actionsTypes.FETCH_DATA_STYLES, fetchDataStyles),
    takeLatest(actionsTypes.FETCH_DATA, fetchData)
  ])
}

